
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Shield, CreditCard, TrendingUp, ArrowRight } from "lucide-react";
export const HeroSection = () => {
  return <section className="pt-24 pb-12 md:pt-32 md:pb-16 lg:pt-40 lg:pb-24 relative overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img src="/images/hero.png" alt="People using financial services" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/40 mix-blend-multiply" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/30 to-transparent" />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-block animate-in slide-in-from-bottom-4 duration-1000">
            <span className="px-4 py-1.5 rounded-full bg-white/30 text-sm md:text-base font-medium mb-4 inline-block backdrop-blur-sm text-indigo-600 shadow-sm">
              Secure Financial Solutions
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 md:mb-8 animate-in slide-in-from-bottom-6 duration-1000 drop-shadow-lg lg:text-7xl tracking-tight">
            The credit guarantee cheque powered by your asset equity
          </h1>
          <p className="md:text-xl mb-8 md:mb-10 animate-in slide-in-from-bottom-8 duration-1000 px-4 md:px-0 drop-shadow-md lg:text-2xl text-xl font-medium text-slate-50 max-w-3xl mx-auto">Obotan credit guarantee cheque enables for loan crowdfunding and credit purchases</p>
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 animate-in slide-in-from-bottom-10 duration-1000 px-4 md:px-0">
            <Button asChild size="lg" className="w-full md:w-auto gap-2 shadow-lg hover:shadow-primary/25 transition-all duration-300 bg-indigo-600 hover:bg-indigo-700 text-white">
              <Link to="/register">
                <CreditCard className="h-5 w-5" />
                Apply for Loan
                <ArrowRight className="ml-1 h-4 w-4" />
              </Link>
            </Button>
            <Button asChild variant="secondary" size="lg" className="w-full md:w-auto gap-2 hover:shadow-lg transition-all duration-300 bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm border border-white/20">
              <Link to="/lenders">
                <TrendingUp className="h-5 w-5" />
                View Lenders
              </Link>
            </Button>
          </div>
          <div className="mt-12 md:mt-16 flex flex-wrap items-center justify-center gap-4 md:gap-8 text-sm md:text-base text-white animate-in slide-in-from-bottom-12 duration-1000 py-6 px-4 backdrop-blur-sm bg-indigo-600/10 rounded-xl border border-indigo-600/20 shadow-lg">
            <div className="flex items-center gap-3 px-4 py-2 rounded-full backdrop-blur-sm bg-indigo-600/80 hover:bg-indigo-600 transition-colors duration-300 shadow-sm">
              <Shield className="h-5 w-5 md:h-6 md:w-6" />
              <span>Asset-Backed Security</span>
            </div>
            <div className="flex items-center gap-3 px-4 py-2 rounded-full backdrop-blur-sm bg-indigo-600/80 hover:bg-indigo-600 transition-colors duration-300 shadow-sm">
              <CreditCard className="h-5 w-5 md:h-6 md:w-6" />
              <span>Competitive Rates</span>
            </div>
            <div className="flex items-center gap-3 px-4 py-2 rounded-full backdrop-blur-sm bg-indigo-600/80 hover:bg-indigo-600 transition-colors duration-300 shadow-sm">
              <TrendingUp className="h-5 w-5 md:h-6 md:w-6" />
              <span>Quick Approval</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
